import c from "./consts";
import authConsts from "./modules/auth/consts";

export default {
    async [c.INIT_APP]({state, commit, dispatch}) {
        if (state[c.APP_INITIALIZED]) {
            return;
        }

        try {
            await dispatch(
                `${authConsts.STORE_PATH}/${authConsts.INITIALIZE_AUTH}`,
                null,
                { root: true }
            );
        }
        finally {
            commit(c.APP_INITIALIZED, true);
        }
    },
};